module.exports = __webpack_public_path__ + "static/media/silvio01.a8b9e28a.gif";